import { render } from "./ProjectSectionTimelineFollowAction.vue?vue&type=template&id=676c2d30"
import script from "./ProjectSectionTimelineFollowAction.vue?vue&type=script&lang=js"
export * from "./ProjectSectionTimelineFollowAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__